/* src/components/HorizontalScroll/panelStatus.js */
import { createContext, useContext } from 'react'

/**
 * Статус панелі відносно активної секції горизонтального скролу:
 *   'after'  — ще не дійшли до неї (попереду по треку)
 *   'active' — вона зараз по центру і доведена (settled)
 *   'before' — ми пройшли її далі (позаду по треку)
 *   'static' — горизонтальний скрол вимкнено (мобілка / reduced-motion)
 */
export const PanelStatusContext = createContext('static')

export const usePanelStatus = () => useContext(PanelStatusContext)